/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 *
 * POC COPY — source of truth lives at
 *   cds-ai-service/frontend/src/views/dev-chat/chat-stream/StreamingMessage.styles.js
 * See ./README.md for the extraction plan.
 */

import { getCommandIntelligenceTokens } from '../../../theme/commandIntelligenceTokens';

export const getStreamingMessageStyles = theme => {
  const tokens = getCommandIntelligenceTokens(theme);

  return {
    content: {
      color: tokens.textPrimary,
      fontFamily: tokens.fontStack,
      fontSize: '0.97rem',
      lineHeight: 1.7,
      letterSpacing: '-0.005em',
      fontFeatureSettings: '"cv11", "ss01"',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      animation: 'streamingContentFadeIn 220ms ease-out',
      '@keyframes streamingContentFadeIn': {
        from: { opacity: 0, transform: 'translateY(2px)' },
        to: { opacity: 1, transform: 'translateY(0)' },
      },
      '& p': {
        my: 0,
        mb: 1.25,
        '&:last-child': {
          mb: 0,
        },
      },
      '& h1, & h2, & h3': {
        mt: 1.5,
        mb: 1,
        lineHeight: 1.3,
      },
      '& ul, & ol': {
        mt: 0.5,
        mb: 1,
        pl: 2.5,
      },
    },
    caret: {
      display: 'inline-block',
      width: 6,
      height: 6,
      borderRadius: '50%',
      verticalAlign: 'middle',
      marginLeft: 0.75,
      backgroundColor: tokens.textSecondary,
      animation: 'streamingCaretPulse 1.4s ease-in-out infinite',
      '@keyframes streamingCaretPulse': {
        '0%, 100%': { opacity: 0.35, transform: 'scale(0.9)' },
        '50%': { opacity: 0.9, transform: 'scale(1.1)' },
      },
    },
  };
};
